"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var listen = [{
  pattern: {
    "IOS|FINO": ["gte", "1.0.0"],
    "ANDROID|FINO": ["gte", "1.0.0"]
  },
  handler: function handler(func) {
    return this.register(func);
  }
}, {
  pattern: {
    "IOS|FINO": ["gte", "1.0.0"],
    "ANDROID|FINO": ["gte", "1.0.0"]
  },
  handler: function handler(func) {
    return this.register(func);
  }
}];

exports.default = listen;